// Import all icons
import closeIcon from './close.png';
import menuIcon from './menu.png';
import loopIcon from './loop.png';
import artIcon from './art.png';
import filmIcon from './film.png';
import architectureIcon from './architecture.png';
import literatureIcon from './literature.png';
import historyIcon from './history.png';
import starIcon from './star.png';
import starRetina from './star-x1.5.png';
import nextIcon from './next.png';
import mapIcon from './map.png';

// Export as object for easier access
export const icons = {
  close: closeIcon,
  menu: menuIcon,
  loop: loopIcon,
  art: artIcon,
  film: filmIcon,
  architecture: architectureIcon,
  literature: literatureIcon,
  history: historyIcon,
  star: starIcon,
  starRetina: starRetina,
  next: nextIcon,
  map: mapIcon
};

// Also export individually for flexibility
export {
  closeIcon,
  menuIcon,
  loopIcon,
  artIcon,
  filmIcon,
  architectureIcon,
  literatureIcon,
  historyIcon,
  starIcon,
  starRetina,
  nextIcon,
  mapIcon
};
